class Ledger {
	constructor() {
		this.commodity = null //string
		this.currency = null //string
		this.mb_bank_details = null
		// {
		//   account_number: null,
		//   bank_name: null,
		//   ifsc_code: null
		// },
		this.money_transaction_type = 'DEBIT' //string // credit/debit with respect to metalbook
		this.transaction_amount = 0
		this.transaction_date = new Date().getTime()
		this.transaction_id = null //string
		this.transaction_remarks = null //string
		this.transaction_source = 'DEPOSIT' //string // bill(invoice)/credit(dis)/deposit
		this.transaction_type = null //string //sale/purchase
		this.user_bank_details = null
		// {
		//   this.account_number = null; //string
		//   this.bank_name = null; //string
		//   this.ifsc_code = null; //string
		// };
		this.user_details = null

		this.access_type = 'web' //string
		this.updated_at = new Date().getTime() //date
		this.updated_by = ''
		this.created_at = new Date().getTime() //date
		this.created_by = ''
		this.platform = 'MARKETPLACE'

		// Add Missing keys

		this.currency_id = null
		this.order_id = null
		this.order_date = null

		this.original_document_number = null

		this.oracle_transaction_type = null

		this.original_transaction_amount = null
		this.refund_transaction_amount = null
		this.running_balance = null

		this.exchange_rate = null

		this.invoice_source = null
		this.invoice_reference = null
		this.billing_address = null // GstDetail

		this.zoho_reference_id = null

		this.tds = null
		this.tcs = null
		this.credit_note_amount = null
		this.round_off = null
		this.balance = null

		this.taxes = null
		this.due_date = null

		this.zoho_document = null
		this.zoho_status = null

		this.trading_expense = false
		this.payment_terms = null
		this.sales_person = null
		this.paid_on = null

		this.sales_manager = null
		this.procurement_manager = null
		this.manager_added = false

		this.region = null
		this.other_items = [] // List<OtherItem>

		this.complimentary_reference_number = null
	}
}

export default Ledger
